export default {
    omitExtraWLInCodeBlocks: true,
    noHeaderId: true,
    headerLevelStart: 1,
    simplifiedAutoLink: true,
    simpleLineBreaks: true,
    requireSpaceBeforeHeadingText: true,
    openLinksInNewWindow: true,
    emoji: true,
}